import { createSelector } from 'reselect';

const ppt = state => state.get('pptReducer');

const pptDownloadingSelector = () => createSelector(ppt, state => state.downloading);

export default pptDownloadingSelector;
